/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Subscriptionhistory1Inputs */

const zh_billing_subscriptionhistory1 = /** @type {(inputs: Billing_Subscriptionhistory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅记录`)
};

const en_billing_subscriptionhistory1 = /** @type {(inputs: Billing_Subscriptionhistory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription History`)
};

const es_billing_subscriptionhistory1 = /** @type {(inputs: Billing_Subscriptionhistory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de suscripciones`)
};

/**
* | output |
* | --- |
* | "Subscription History" |
*
* @param {Billing_Subscriptionhistory1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const billing_subscriptionhistory1 = /** @type {((inputs?: Billing_Subscriptionhistory1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Subscriptionhistory1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_subscriptionhistory1(inputs)
	if (locale === "en") return en_billing_subscriptionhistory1(inputs)
	return es_billing_subscriptionhistory1(inputs)
});
export { billing_subscriptionhistory1 as "billing_subscriptionHistory" }